import { styled } from '@mui/material';

import { StyledIcon } from '../StyledIcon';

const StyledClearIcon = styled(StyledIcon)`
  padding-top: 0.2rem;
`;

export function ClearIcon(props) {
  const { size = 17, color, className } = props;

  return (
    <StyledClearIcon color={color}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 17 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
      >
        <path
          d='M2.98438 2.5L14.9843 14.5'
          stroke='currentColor'
          strokeWidth='1.4'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
        <path
          d='M2.98438 14.5L14.9844 2.5001'
          stroke='currentColor'
          strokeWidth='1.4'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
      </svg>
    </StyledClearIcon>
  );
}
